import { useCallback, useMemo, useRef, useState } from 'react';
import List from 'devextreme-react/list';
import { useAppSelector } from '../../../contexts/hooks';
import { formatMessage } from 'devextreme/localization';
import './UserMenuSection.scss';
import type { UserMenuSectionProps } from '../../../types';
import { UserState } from '../../../types/types.user';
import DefaultAvantar from '../../../images/defaulAvatar.png';
import useSessionManager from '../session-manager/useSessionManager';
import Form, { RequiredRule, SimpleItem } from 'devextreme-react/form';
import { Button, Popup } from 'devextreme-react';
import { useScreenSize } from '../../../utils/media-query';
import { ToolbarItem } from 'devextreme-react/popup';
import { useApiConfigUsuarios } from '../../../api/api.ConfigUsuarios';
import { newToast } from '../..';

const dataChangePassword = {
  oldPassword: null,
  newPassword: null,
  PasswordConfirm: null,
};
export const UserMenuSection = ({ showAvatar, listRef }: UserMenuSectionProps) => {
  const { logout } = useSessionManager();
  const systemLocations = useAppSelector((data) => data.configuration.Data?.ComboBox)?.find((x) => x.Name === 'SysI_Sedes')?.Data;
  const EstadoConex = useAppSelector((x) => x.signalR.DataChangeIsconnected);
  const [modalChangePassword, setModalChangePassword] = useState(false);
  const { changePassword } = useApiConfigUsuarios();
  const UsInf = useAppSelector((user) => user.userInfo) as UserState;
  const { isSmall, isXSmall } = useScreenSize();
  const frmRef = useRef<Form>(null);
  const Prm_CamPass = useAppSelector((x) => x.userInfo.Permissions?.Prm_CamPass) ?? false;

  const listElementAttr = {
    class: 'user-info-list',
  };

  const handleClicChangePassword = useCallback(() => {
    if (!Prm_CamPass) {
      newToast('WARNING', 'No cuenta con los permisos para cambiar la contraseña', 4);
      return;
    }
    setModalChangePassword(true);
  }, [setModalChangePassword]);

  const handleCloseModalChangePassword = useCallback(() => {
    setModalChangePassword(false);
  }, [setModalChangePassword]);

  const onItemClick = (itemData) => {
    if (itemData && itemData.onClick) {
      itemData.onClick();
    }
  };

  const handleClicSaveChangePassword = useCallback(() => {
    const form = frmRef.current?.instance;
    if (!form) {
      return;
    }
    const isValid = form.validate().isValid;
    if (!isValid) return;

    // Implement the logic to save the new password here
    changePassword(dataChangePassword).finally(() => {
      if (!Prm_CamPass) {
        newToast('WARNING', 'No cuenta con los permisos para cambiar la contraseña', 4);
        return;
      }
      setModalChangePassword(false);
      form.resetValues();
    });
  }, [changePassword, dataChangePassword, frmRef]);

  const menuItems = useMemo(
    () => [
      {
        text: formatMessage('MyProfile'),
        icon: 'user',
        onClick: () => {},
      },
      {
        text: formatMessage('ChangePassword'),
        icon: 'key',
        onClick: handleClicChangePassword,
      },
      {
        text: formatMessage('LogOut'),
        icon: 'runner',
        onClick: logout,
      },
    ],
    [logout, handleClicChangePassword]
  );

  return (
    <>
      <div className='user-info'>
        {showAvatar && (
          <div className='image-container'>
            <img className='user-image' src={DefaultAvantar} alt='avatar' />
          </div>
        )}
        <div className='user-name'>
          <p>
            {UsInf?.User?.Us_Nombre} {UsInf?.User?.Us_Apellido1} {UsInf?.User?.Us_Apellido2}
          </p>
        </div>
        <div className='user-name profile-name'>
          <p>
            {formatMessage('Profile')}: {UsInf?.Profile?.Pe_Nombre}
          </p>
        </div>
        <div className='user-name sede-name'>
          <p>
            {formatMessage('Location')}: {systemLocations?.filter((x) => x.Sd_Id === UsInf?.Location)[0].Sd_Nombre}
          </p>
          <div>
            <span className={`status-dot ${EstadoConex ? 'green' : 'red'}`}></span>
            <span className='status-text'>{EstadoConex ? 'Conectado' : 'Desconectado'}</span>
          </div>
        </div>
      </div>
      <List ref={listRef} elementAttr={listElementAttr} onItemClick={onItemClick} items={menuItems} />
      <Popup title='Cambiar contraseña' showCloseButton width={400} fullScreen={isSmall || isXSmall} height={'auto'} visible={modalChangePassword} onHidden={handleCloseModalChangePassword}>
        <Form formData={dataChangePassword} ref={frmRef} showValidationSummary validationGroup='ValidationForm' labelLocation='left' className='plain-styled-form'>
          <SimpleItem dataField='oldPassword' isRequired label={{ text: 'Actual contraseña' }} editorOptions={{ mode: 'password' }}>
            <RequiredRule message='Ingrese la contraseña actual' />
          </SimpleItem>
          <SimpleItem dataField='newPassword' isRequired label={{ text: 'Nueva contraseña' }} editorOptions={{ mode: 'password' }}>
            <RequiredRule message='La nueva contraseña es requerida' />
          </SimpleItem>
          <SimpleItem dataField='PasswordConfirm' label={{ text: 'Confirmar nueva contraseña' }} isRequired editorOptions={{ mode: 'password' }}>
            <RequiredRule message='Debe confirmar la nueva contraseña' />
          </SimpleItem>
        </Form>
        <ToolbarItem toolbar='bottom' location='after'>
          <div className={`form-popup-buttons-container`}>
            <Button stylingMode='contained' type={'default'} onClick={handleClicSaveChangePassword} text='Guardar' />
          </div>
        </ToolbarItem>
      </Popup>
    </>
  );
};
